export default "__VITE_ASSET__11f3931b__"